import React, { useState } from 'react';
import { toast } from 'sonner';
import { listSeoPages, evaluateIndexing, formatSeoApiError } from '../../../utils/adminSeo';

export default function SeoIndexingScreen() {
  const [pages, setPages] = useState([]);
  const [result, setResult] = useState(null);

  const load = () => {
    listSeoPages({ limit: 100 })
      .then((r) => setPages(r.pages || []))
      .catch((e) => toast.error(formatSeoApiError(e)));
  };

  React.useEffect(() => {
    load();
  }, []);

  const runEval = async (pageId) => {
    try {
      const res = await evaluateIndexing(pageId);
      setResult(res);
      toast.success('Indexing evaluated');
      load();
    } catch (e) {
      toast.error(formatSeoApiError(e));
    }
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Indexing Control</h2>
      <p className="text-sm text-gray-600">Re-run auto noindex rules and refresh indexable flag per page.</p>
      <ul className="border rounded bg-white max-h-[50vh] overflow-y-auto text-sm">
        {pages.map((p) => (
          <li key={p.id} className="border-b p-2 flex justify-between gap-2">
            <span>
              {p.page_type}/{p.slug} — {p.indexable ? 'index' : 'noindex'} (P{p.entity_priority ?? '?'})
            </span>
            <button
              type="button"
              className="text-xs underline text-[#659A9B] shrink-0"
              onClick={() => runEval(p.id)}
            >
              Evaluate
            </button>
          </li>
        ))}
      </ul>
      {result && (
        <pre className="text-xs bg-amber-50 border rounded p-3">{JSON.stringify(result, null, 2)}</pre>
      )}
    </div>
  );
}
